import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UserRole } from '@scripts/utils/user-roles';
import { AuthService } from '@scripts/woo_services.module/AuthService';
import { BaseModalComponent } from '../base-modal/base-modal.component';
import { ModalLayoutComponent } from '../base-modal/modal-layout/modal-layout.component';

@Component({
  selector: 'app-search-info-modal',
  imports: [ModalLayoutComponent, CommonModule, FormsModule],
  templateUrl: './search-info-modal.component.html',
  styleUrl: './search-info-modal.component.scss',
})
export class SearchInfoModal extends BaseModalComponent<{ supportPhone: string }> {
  private authService = inject(AuthService);
  readonly showTTVFields = this.authService.hasAnyRole([UserRole.planner, UserRole.admin, UserRole.accounting]);
}
